import apiTool from './index';

const GET_QUESTIONS_URL = 'question/get-questions/';
const ADD_QUESTION_URL = 'question/add-question/';
const UPDATE_QUESTION_URL = 'question/update-question/'
const DELETE_QUESTION_URL = 'question/delete-question/'
const GET_QUESTION_URL = 'question/get-question/';

export default {
    getQuestions(payload) {
    return apiTool.post(GET_QUESTIONS_URL, payload);
    },
    getQuestion(question_id) {
    return apiTool.get(GET_QUESTION_URL + question_id + '/');
    },
    addQuestion(payload) {
    return apiTool.post(ADD_QUESTION_URL, payload);
    },
    updateQuestion(payload) {
    return apiTool.post(UPDATE_QUESTION_URL + payload.id + '/', payload);
    },
    deleteQuestion(question_id) {
    return apiTool.delete(DELETE_QUESTION_URL + question_id + '/');
    },
}